/** Versão do termo: números separados por ponto (`1`, `1.0`, `2.10.3`). */
const PADRAO_VERSAO = /^\d+(\.\d+)*$/;

export function isFormatoVersaoValido(versao: string): boolean {
  return PADRAO_VERSAO.test(versao.trim());
}

/**
 * Compara duas versões segmento a segmento: negativo se `a` vem antes de `b`,
 * zero se equivalem, positivo se `a` vem depois.
 *
 * A comparação é numérica, e não textual, porque "10.0" é posterior a "9.0"
 * embora venha antes na ordem alfabética. Segmentos ausentes contam como zero,
 * então "3" e "3.0" são a mesma versão.
 */
export function compararVersoes(a: string, b: string): number {
  const segmentosA = segmentos(a);
  const segmentosB = segmentos(b);
  const total = Math.max(segmentosA.length, segmentosB.length);

  for (let i = 0; i < total; i++) {
    const diferenca = (segmentosA[i] ?? 0) - (segmentosB[i] ?? 0);

    if (diferenca !== 0) {
      return diferenca;
    }
  }

  return 0;
}

function segmentos(versao: string): number[] {
  return versao
    .trim()
    .split('.')
    .map((parte) => Number(parte) || 0);
}
